import OnboardingTutorialSetup from './components/OnboardingTutorialSetup.js';
import connect from './connect';
import './assets/OnboardingTutorialSetup.css';

export default connect(OnboardingTutorialSetup);



// WEBPACK FOOTER //
// ./src/routes/OnboardingTutorialSetup/index.js